<template>
  <div class="private-info">
    <account-description :title="$t('private.info')">{{ $t('private.info.page.description') }}</account-description>
    <private-info-form />
  </div>
</template>

<script>
import AccountDescription from '@/components/account/AccountDescription.vue';
import PrivateInfoForm from '@/components/account/privateInfo/PrivateInfoForm.vue';

export default {
  components: {
    AccountDescription,
    PrivateInfoForm,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';

.private-info {
  max-width: $account-input-width;
  min-height: 100%;
}
</style>
